import React from 'react';
import './SearchInput.css';

const SearchInput = (props, { parentStyle = {}, InputProps = {} }) => {
  return (
    <div id='adminSearch' style={{ ...props.parentStyle }}>
      <input
        {...props.InputProps}
        name={props.InputProps.name ? props.InputProps.name : 'text'}
        autoComplete='off'
        type='search'
        placeholder={
          props.InputProps.placeholder
            ? props.InputProps.placeholder
            : 'Search by Name or Mobile'
        }
        className='searchInput'
        onChange={props.onChange}
        value={props.value}
      />
    </div>
  );
};

export default SearchInput;
